import React, { useEffect } from 'react';
import { NavigationContainer, Route } from '../navigation/native';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider, useDispatch } from 'react-redux';
import { Provider as PaperProvider } from '../components/paper';
import { MsalAuthenticationTemplate, useIsAuthenticated } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import Navigation from './Navigation';
import store, { persistor } from '../store';
import { userActions } from '../store';
import { AppDispatch } from '../store/store';
import { DatadogProvider } from '../logging/datadog';
import { getDatadogConfig, onDatadogInitialization } from '../logging/ddUtils';
import { DdRumReactNavigationTracking, ViewNamePredicate } from '../logging/ddNavigation';
import { loginRequest } from '../services/auth/msalConfig';
import { getUser } from '../services/auth/Auth';

const viewNamePredicate: ViewNamePredicate = function customViewNamePredicate(route: Route<string, any | undefined>, trackedName: string) {
  return trackedName || route.name
}

/** Mirrors the signed-in MSAL account into Redux for components that read `selectUser`. */
const MsalUserSync = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    dispatch(userActions.setUser(getUser()));
  }, [dispatch, isAuthenticated]);

  return null;
};

const App = () => {
  const navigationRef = React.useRef(null);
  return (
    <DatadogProvider configuration={getDatadogConfig()} onInitialization={onDatadogInitialization}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <PaperProvider>
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
              authenticationRequest={loginRequest}>
              <MsalUserSync />
              <NavigationContainer ref={navigationRef} onReady={() => {
                DdRumReactNavigationTracking.startTrackingViews(navigationRef.current, viewNamePredicate)
              }}>
                <Navigation />
              </NavigationContainer>
            </MsalAuthenticationTemplate>
          </PaperProvider>
        </PersistGate>
      </Provider>
    </DatadogProvider>
  );
};

export default App;